import { ESdChangeReason, ViewPart, Visibility } from "@kuika/kuika-cl-model";
import { IWithSDProps, withSD } from "../../../../shared/hoc/screen-design-consumer";
import { IWithContextProp, withContext } from "../../../../shared/hoc/with-context";
import { IWithHistoryProp, withHistory } from "../../../../shared/hoc/with-history";
import { PureSdComponent } from "../../../../shared/pure-sd";
import { AlternativeScreensModal } from "../alternative-screens-modal";
import { KuikaLogo } from "../kuika-logo/kuika-logo";
import { ToolbarLeft } from "../toolbar-left/toolbar-left";
import { ToolbarRight } from "../toolbar-right/toolbar-right";
import { WorkspaceBranch } from "../workspace-branch";
import "./toolbar.scss";

export interface IToolBarState {}

export interface IToolBarProps {}

class ToolBar extends PureSdComponent<
  IToolBarProps & IWithSDProps & IWithContextProp & IWithHistoryProp,
  IToolBarState
> {
  constructor(props: IToolBarProps & IWithSDProps & IWithContextProp & IWithHistoryProp) {
    super(props);
    this.state = {
      showSaveTemplateModal: false,
      templateName: "",
      isTemplateSubmitButtonLoading: false
    };
  }

  render() {
    return (
      <>
        <AlternativeScreensModal alternativeSdList={this.props.sd.alternativeSdList} />
        {this.props.sd.getVisibility(ViewPart.Toolbar) === Visibility.Visible && (
          <div className="kuika-toolbar" data-testid="kuikaHeader">
            {/* Three logical regions. The center column holds the navigation tabs and is
                genuinely centred by the grid (both side columns are equal `1fr`), so it stays
                put as tabs expand/collapse. Left carries brand + workspace identity;
                right carries the contextual project actions and the branch selector. */}
            <div className="kuika-toolbar__region kuika-toolbar__region--left">
              <KuikaLogo />
              <WorkspaceBranch />
            </div>
            <div className="kuika-toolbar__region kuika-toolbar__region--center">
              <ToolbarLeft />
            </div>
            <div className="kuika-toolbar__region kuika-toolbar__region--right">
              <ToolbarRight />
            </div>
          </div>
        )}
      </>
    );
  }

  checkNeedRender = (changeReason: ESdChangeReason): boolean => {
    return false;
  };
}

const toolBar = withContext<IToolBarProps>(withHistory<IToolBarProps>(withSD<IToolBarProps>(ToolBar)));
export { toolBar as ToolBar };
